import { useAccountUpdateApiVersionMutation } from '~/generated/graphql';

export function useUpdateAPIVersion() {
  const [updateAPIVersion] = useAccountUpdateApiVersionMutation();

  return {
    updateAPIVersion,
  };
}
